import { useQuery } from '@tanstack/react-query';

import { addressesAPI } from '../api/address';

/**
 * Доставляем ли по этой точке.
 *
 * `/branch/nearby` отвечает 200 и в том, и в другом случае: в зоне — филиал
 * с полигоном, вне зоны — `success: false` с готовым текстом («Этот адрес
 * недоступен для доставки»). Свой словарь под это не нужен.
 *
 * Отказ сети трактуем как «доставляем»: не наше дело запрещать сохранение
 * из-за собственного сбоя — такой адрес отсеется при оформлении заказа.
 */
export const useDeliveryAvailability = ([lat, lng]: [number, number]) => {
  const { data, isFetching } = useQuery({
    // Округляем до пяти знаков (~1 м): иначе каждое дрожание карты — новый
    // запрос.
    queryKey: ['delivery-availability', lat.toFixed(5), lng.toFixed(5)],
    queryFn: async () => {
      const res = await addressesAPI.getNearBranch(lat, lng);

      return {
        isAvailable: Boolean(res?.data?.success),
        message: res?.data?.message ?? '',
      };
    },
    enabled: Boolean(lat && lng),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    isAvailable: data?.isAvailable ?? true,
    message: data?.isAvailable === false ? data.message : '',
    isChecking: isFetching,
  };
};
